import React from "react";
import FlightListItemSkeleton from "./FlightListItemSkeleton";

const SK = `
.hw-flsk .fbx{background:#e9edf3;border-radius:8px;animation:hwFlskPulse 1.4s ease-in-out infinite;display:block}
@keyframes hwFlskPulse{0%,100%{opacity:1}50%{opacity:.5}}
.hw-flsk--filterTop{display:flex;align-items:center;justify-content:space-between;gap:12px;}
.hw-flsk--row{display:flex;align-items:center;gap:10px;margin-bottom:12px;}
`;

const Bx = ({ w, h, r = 8, mb = 0, style }) => (
  <span className="fbx" style={{ width: w, height: h, borderRadius: r, marginBottom: mb, ...style }} />
);

const FilterWidgetSkeleton = ({ rows = 4 }) => (
  <div className="hw-search--flightFilter__widget">
    <Bx w="42%" h={14} mb={16} />
    {Array.from({ length: rows }).map((_, i) => (
      <div className="hw-flsk--row" key={i}>
        <Bx w={18} h={18} r={5} />
        <Bx w={`${48 + (i % 3) * 14}%`} h={12} />
      </div>
    ))}
  </div>
);

export const FlightListLoadingSkeleton = ({ cards = 5 }) => (
  <div className="hw-page--width hw-flsk">
    <style>{SK}</style>
    <div className="hw-search--flightList">
      <aside className="hw-search--flightFilter">
        <div className="hw-search--flightFilter__top">
          <div className="hw-flsk--filterTop">
            <Bx w="96px" h={16} />
            <Bx w="54px" h={14} />
          </div>
        </div>
        <div className="hw-search--flightFilter__body">
          <FilterWidgetSkeleton rows={2} />
          <FilterWidgetSkeleton rows={3} />
          <FilterWidgetSkeleton rows={4} />
          <FilterWidgetSkeleton rows={4} />
        </div>
      </aside>
      <div className="hw-search--flightFilterResult">
        <div className="hw-search--flightFilterResult__body">
          <ul className="hw-search--flightFilterResult__list list-unstyled">
            {Array.from({ length: cards }).map((_, i) => (
              <FlightListItemSkeleton key={i} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default FlightListLoadingSkeleton;
